import { List, ListItem, ListItemAvatar, ListItemText, ListSubheader } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import axios from "axios";
import { ChatAvatar } from "../ChatModule/components/ChatAvatar";
import { combineProps } from "../../../helpers/objectHelper";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { SpeakerNotesOffSharp } from "@material-ui/icons";
export const SpeakerList = (props) => {
  const [speakers, setSpeakers] = useState([]);
  const [activeSpeakers, setActiveSpeakers] = useState([]);
  const [activeAgenda, setActiveAgenda] = useState(null);

  const { eventId, lang, hubConnection, orderList, preview, connectionList } = props;

  useEffect(() => {
    init(eventId, "DigitalMeeting.SpeakerList", lang);
    if (!preview) {
      fetchSpeakers();
      configureHubEvents();
      fetchAgenda();
    }
  }, []);

  const configureHubEvents = () => {
    if (hubConnection) {
      hubConnection.on("onSpeakersUpdate", (speakers) => setSpeakers(speakers));
      hubConnection.on("onActivateSpeaker", (activeSpeaker) => {
        if (activeSpeakers.find((a) => a.badgeNo == activeSpeaker.badgeNo)) {
          setActiveSpeakers([...activeSpeakers.splice(activeSpeakers.indexOf(activeSpeaker), 1)]);
        } else setActiveSpeakers(...activeSpeakers, activeSpeaker);
      });
      hubConnection.on("onDeactivateSpeaker", (badgeNo) => setActiveSpeakers([...activeSpeakers.splice(activeSpeakers.indexOf(activeSpeakers.find((a) => a.badgeNo == badgeNo)), 1)]));
    }
  };

  const fetchSpeakers = () => {
    axios
      .get(`./api/meeting/speakers/${eventId}`)
      .then(({ data }) => {
        if (data) {
          setSpeakers(data);
          const active = data.filter((a) => a.active == true);

          if (active && active.length > 0) setActiveSpeakers([...activeSpeakers, active]);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const fetchAgenda = () => {
    axios
      .get(`./api/meeting/agenda/${eventId}`)
      .then(({ data }) => {
        if (!data) return;
        const agendaItems = data.sort(function (a, b) {
          return a.sortOrder - b.sortOrder;
        });
        setActiveAgenda(agendaItems.find((a) => a.active == true));
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
        <Typography>
          <EventLabel2 name="UpcomingSpeakers" groupName="DigitalMeeting.SpeakerList" />{" "}
          <span style={{ marginLeft: 5 }}>{speakers.filter((s) => s.closedDateTime == null && s.active != true).length}</span>
        </Typography>
      </AccordionSummary>
      <AccordionDetails className="jir-scroll" style={{ display: "block", maxHeight: 350, padding: 6, overflowY: "auto" }}>
        {speakers.filter((s) => s.closedDateTime == null && s.active == false).length > 0 ? (
          <List
            dense={true}
            /*   subheader={
              <ListSubheader className="list-subheader" component="div" id="nested-list-subheader">
                <div className="dot" style={{ background: "#bddcea" }} /> <span style={{ marginRight: 5 }}>{speakers.filter((s) => s.closedDateTime == null && s.active != true).length}</span>{" "}
                <EventLabel2 name="UpcomingSpeaker" groupName="DigitalMeeting.SpeakerList" />
              </ListSubheader>
            } */
          >
            {speakers
              .filter((s) => s.closedDateTime == null && s.active == false && s.agendaItemId == activeAgenda?.agendaItemId)
              .sort((a, b) => {
                return +new Date(a.inserted) - +new Date(b.inserted);
              })
              .map((s) => {
                const person = orderList.find((o) => o.badgeNo == s.badgeNo);
                if (!person) return null;
                return (
                  <ListItem key={s.interactionSpeakerId}>
                    <ListItemAvatar>
                      <ChatAvatar
                        {...combineProps([
                          props,
                          {
                            connectionList,
                            orderList,
                            primaryColor: "#e4e6eb",
                            secondaryColor: "#fff",
                            target: person.badgeNo,
                          },
                        ])}
                      >
                        <AccountCircleIcon />
                      </ChatAvatar>
                    </ListItemAvatar>
                    <ListItemText primary={person.name} secondary={person.company} />
                  </ListItem>
                );
              })}
          </List>
        ) : null}
      </AccordionDetails>
    </Accordion>
  );
};
